import { render, staticRenderFns } from "./waterScatterChart.vue?vue&type=template&id=47f20634&"
import script from "./waterScatterChart.vue?vue&type=script&lang=js&"
export * from "./waterScatterChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports